<template>
	<div>
		<b-card-group columns style="column-count:2">
			<b-card img-bottom :img-src="p.url" v-for="p in photos" @click="show(p)">
				<h5 class="p-0 m-0">{{ cleanFilename(p.filename) }}</h5>
			</b-card>
		</b-card-group>
		<b-modal id="photo-modal" :title="cleanFilename(photo.filename)">
			<b-img :src="photo.url" fluid/>
		</b-modal>
	</div>
</template>
<script>

export default {
	name: "ModalGallery",
	props: [ 'photos' ],
	data: () => ({
		photo: {} 
	}),
	methods: {
		show (photo) {
			this.photo = photo;
			this.$bvModal.show('photo-modal')
		},
		cleanFilename(f) {
			return f?f.split('.').slice(0,-1).join('.'):'';
		}
	}
}

</script>
